// extracted by mini-css-extract-plugin
export default {"ripple-container":"Ripple_ripple-container__9zlN8","ripple":"Ripple_ripple__SePlA","ripple-effect":"Ripple_ripple-effect__1sRyz","content":"Ripple_content__fhiuu"};